module.exports = __webpack_public_path__ + "static/img/iGlobal@2x.67fa38d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/new_home/iGlobal@2x.png
// module id = 467
// module chunks = 0